import { render, staticRenderFns } from "./ButtonVideoCall.vue?vue&type=template&id=c558c70c&scoped=true&"
import script from "./ButtonVideoCall.vue?vue&type=script&lang=js&"
export * from "./ButtonVideoCall.vue?vue&type=script&lang=js&"
import style0 from "./ButtonVideoCall.vue?vue&type=style&index=0&id=c558c70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c558c70c",
  null
  
)

export default component.exports